import React from "react";

// EXTRAS
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { TypographyBoldOnPrint } from "../styled";
import { DottedBorderBox } from "../styled/superficies";

export default function OrderTicketBottom({
  orderType,
  orderIndex,
  indoorTable,
  changeFor,
}) {
  return (
    <Box>
      <TypographyBoldOnPrint
        variant="h3"
        align="center"
        fontWeight="bold"
        printsize={45}
        color={grey["900"]}
      >
        {orderType !== "INDOOR" ? orderIndex : `SALÃO ${indoorTable}`}
      </TypographyBoldOnPrint>

      {changeFor && changeFor > 0 && (
        <DottedBorderBox>
          <TypographyBoldOnPrint
            variant="h5"
            align="center"
            fontWeight="bold"
            printsize={45}
            color={grey["900"]}
          >
            ALERTA DE TROCO
          </TypographyBoldOnPrint>
        </DottedBorderBox>
      )}
    </Box>
  );
}
